export default __webpack_public_path__ + "static/media/slide_6.48af4398.jpg";